import { Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MobileMenuExtraService {
  private readonly _template = signal<TemplateRef<any> | null>(null);
  private readonly _hideTabs = signal<boolean>(false);

  readonly template = this._template.asReadonly();
  readonly hideTabs = this._hideTabs.asReadonly();

  setTemplate(template: TemplateRef<any>, hideTabs = false) {
    this._template.set(template);
    this._hideTabs.set(hideTabs);
  }

  clearTemplate() {
    this._template.set(null);
    this._hideTabs.set(false);
  }
}
